import { useEffect, useState } from 'react'
import { ButtonBlock, type CommonBlockProps } from '../../../types'
import { webchatClasses } from '../../../styles/classes'
import { useWebchatStore } from '../../../stores'

type Props = ButtonBlock & CommonBlockProps

export const Button = ({ text, buttonValue, variant, groupId, reusable, sendMessage, isReadOnly, ...props }: Props) => {
  const eventEmitter = useWebchatStore((s) => s.eventEmitter)

  const [activated, setActivated] = useState(false)
  const [groupActivated, setGroupActivated] = useState(false)
  const [disabled, setDisabled] = useState(false)

  const {
    message: {
      blocks: { button },
    },
  } = webchatClasses

  // TODO: Remover event emitting and store stage in zustand instead
  useEffect(() => {
    if (!groupId) return
    return eventEmitter.on(`button-group-${groupId}-click`, () => {
      setGroupActivated(true)
      if (!reusable) setDisabled(true)
    })
  }, [eventEmitter, groupId, reusable])

  const onClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if ((disabled || isReadOnly) && variant === 'link') {
      e.preventDefault()
      return
    }

    setActivated(true)

    if (!reusable) setDisabled(true)

    if (groupId) {
      eventEmitter.emit(`button-group-${groupId}-click`)
    }

    if (variant !== 'link' && sendMessage) {
      sendMessage?.({ type: 'text', text, value: buttonValue })
    }
  }

  const commonProps = {
    ...props,
    onClick,
    'data-activated': activated ? '' : undefined,
    'data-group-activated': groupActivated ? '' : undefined,
    'data-type': variant,
    ...button,
  }

  const isButtonDisabled = disabled || isReadOnly

  if (variant === 'link') {
    return (
      <a
        {...commonProps}
        style={isReadOnly ? { pointerEvents: 'none' } : undefined}
        href={buttonValue}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </a>
    )
  }

  return (
    <button {...commonProps} style={isReadOnly ? { pointerEvents: 'none' } : undefined} disabled={isButtonDisabled}>
      {text}
    </button>
  )
}
